import { Component, OnInit } from '@angular/core';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { ActivatedRoute, Router } from '@angular/router';
import { DefineAssetComponent } from "../../client/define-asset/define-asset.component";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { UnsubscriptionError } from 'rxjs';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-configurator-component',
  templateUrl: './configurator-component.component.html',
  styleUrls: ['./configurator-component.component.scss'],
  standalone: true,
  imports: [FormsModule,ReactiveFormsModule,CommonModule]
})
export class ConfiguratorComponentComponent implements OnInit {
  public rotatingAssets = BaseUrlConstantsService.boilerRotatingAssets;
  public get_Boiler_Info = BaseUrlConstantsService.eBoilerRoomApi;
  public today: Date;
  public company_name: string;
  public breadcrumbsArray: any = [
    {
      page_ref: "device-reports",
      page_title: "All Assets",
    },
    {
      page_ref: "#",
      page_title: "Eboiler Configurator",
    }
  ];
  pageName: string;
  public subsystemId: any;
  public clientId: any;
  allDevices: any;
  jsonDevices: any;
  deviceLoader: boolean;
  public allDeviceSecondArray: any =[];
  forCount: any;
  showEmptyError: string;
  public boilerName: string = "";
  public siteName: any;
  public applicationName: any;
  public boilerForm : any;
  tabName:any="";
  public tab1:any="";
  public tab2:any="";
  public tab3:any="";
  public tab4:any="";
  constructor(public router: Router, public dialog: MatDialog,  
    public service: BackendApiService,
    private changeService: ChangeUsersService,
    private activeRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
      this.activeRoute.queryParams.subscribe(params =>{
        // console.log(params,'paramddddddddd')
        this.tabName=params["tabName"];
        this.tab1 = params['tab1']
        this.tab2 = params['tab2']
        this.tab3 = params['tab3']
        this.tab4 = params['tab4']
        this.subsystemId = params['subsystem_id'];
        this.boilerName = params['boilerName'];
        this.applicationName = params['application_name'];
        this.siteName = params['site_name'];
      });
      localStorage.setItem('boiler_name', this.boilerName);
      localStorage.setItem('boiler_site_name',this.siteName);
      localStorage.setItem('boiler_application_name', this.applicationName);
      console.log(this.boilerName,'boilername')
      this.utcTime();
      localStorage.setItem('subsystem_id', this.subsystemId);
      if(localStorage.getItem('role') === 'ADMIN'){
          this.clientId = localStorage.getItem('admin_client_id');
      }else{
        this.clientId = localStorage.getItem('user_id');
      }
     
   }
   public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  ngOnInit(): void {
    this.boilerForm = this.fb.group({
      boiler_name: new FormControl("",  Validators.required),
      serial_number: new FormControl({value:"",disabled: true}, [Validators.required]),
      site_name: new FormControl("", Validators.required),
      application_name: new FormControl("", Validators.required),
      address: new FormControl("", Validators.required),
      country_name: new FormControl("", Validators.required),
      state_name: new FormControl("", Validators.required),
      gateway_address: new FormControl("", Validators.required),
      devic_serial: new FormControl("", Validators.required),
      latitude: new FormControl ("", Validators.required),
      longitude: new FormControl("", Validators.required)
    });
    this.company_name = localStorage.getItem('company_name');
    this.getAssetsList();
    this.getBoilerInfo();
  }
  async goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  //define assets 
  createAssets(){
    if(this.allDeviceSecondArray.length <=3){
      const dialogRef = this.dialog.open(DefineAssetComponent, {
        width: "900px",
        maxWidth: "100%",
        height: "520px",
        panelClass: "custom-modalbox",
        data: {"boiler":"boiler"},
      });
    }else{
      this.service.showError("A maximum of 4 assets can be added to the system");
    }
  }
  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }
  getBoilerInfo() {
    this.service.getData(this.get_Boiler_Info+ "eboiler/" + Math.floor(Math.random() * 90 + 10) + this.clientId + Math.floor(Math.random() * 9000 + 1000) + "/" + this.subsystemId).then(res =>{
      let response = JSON.parse(JSON.stringify(res)).data;
      if(response.status === 'success'){
        if(response.body.length != 0){
          let body = response.body[0];
          this.boilerForm = this.fb.group({
            boiler_name: new FormControl(body.subsystem_name,  Validators.required),
            serial_number: new FormControl({value:body.device_sno,disabled: true}, Validators.required),
            site_name: new FormControl({value: body.site_name, disabled: true}, Validators.required),
            application_name: new FormControl({value: body.application_name, disabled:true}, Validators.required),
            address: new FormControl(body.address, Validators.required),
            country_name: new FormControl(body.country_name, Validators.required),
            state_name: new FormControl(body.state_name, Validators.required),
            latitude: new FormControl(body.latitude, Validators.required),
            longitude: new FormControl(body.longitude, Validators.required),
            // gateway_address: new FormControl(, Validators.required),
            // devic_serial: new FormControl("", Validators.required)
          });
          console.log(body,'body');
        }else{  
          this.service.showError("Something went wrong.");
        }
      }else{
        this.service.showError("Something went wrong");
      }
    });
  }
  async openDetailScreen(sensorData: any, allChild: any) {
    localStorage.setItem('MacAddress', sensorData.mac_address);
    localStorage.setItem('SiteName', allChild.site.name);
    localStorage.setItem('SiteName', allChild.site.name);
    localStorage.setItem('ApplicationName', allChild.application.name);
    const assetChilds = allChild.connected_sensors.filter((x) => {
      return x.device_sno != 1;
    });
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: "managerAssets" === this.pageName ? "managerAssets" : "",
        deviceId: sensorData.inventory_id,
        assetid: sensorData.id,
        label: sensorData.lbl,
        asset_type: sensorData.asset_type,
        sub_type: allChild.sub_type,
        device_serial_no: sensorData.device_sno,
        serial_no: sensorData.sno,
        assetStatus: sensorData.asset_status,
        sensorType: sensorData.sensor,
        no_of_children: assetChilds.length,
        asset_master_info: JSON.stringify(allChild),
        macaddress: sensorData.mac_address,
        route_path:"boiler-configurator",
        tabName:this.tabName,
        tab1:this.tab1,
        tab2:this.tab2,
        tab3:this.tab3,
        tab4:this.tab4,
      },
    };
    this.router.navigate(["detail-nxt"], navigationExtras);
  }
  //get attached assets
  getAssetsList(){
    this.service.getDataWithQuery(this.rotatingAssets + Math.floor(Math.random() * 90 + 10) + this.clientId + Math.floor(Math.random() * 9000 + 1000) + "/" + this.subsystemId + "/eboiler"+"?assetFilter=" + 'ALL'
      +
      "&limit=" +
      100 +
      "&offset=" +
      0  
    ).then(response =>{
      const res = response['data'];
      if (res.status === "success") {
        if (res.body.length !== 0) {
          this.forCount++;
          this.allDevices = res.body; ;
          // this.allDevices = deviceList.filter(device1 =>
          //     this.jsonDevices.some(device2 => device2.id === device1.id)
          // ).map(device1 => {
          //     const device2 = this.jsonDevices.find(device2 => device2.id === device1.id);
          //     return { ...device1, ...device2 };
          // });
          this.changeService.loader(false);
          this.showEmptyError = "";
          this.showEmptyError = "";
          this.allDevices.forEach((e) => {
            e.connected_sensors.sort((a, b) => b.lbl - a.lbl);
            e.noOfSensors = e.connected_sensors.length;
            e.connected_sensors.forEach((s, i) => {
              let sensors = s.template_id.split("_");
              if (sensors !== undefined && sensors.length > 2) {
                //s.sno = i + 1;
                if (s.id === e.id) {
                  s.master = 1;
                } else {
                  s.master = 0;
                }
                s.lbl = sensors[0];
                s.sno = sensors[0];

                s.sensor = sensors[1];
                s.parent = sensors[2];
                if (sensors[2] == "secondry" || sensors[1] == "couple") {
                  e.parentS = true;
                } else {
                  e.parentS = false;
                }
                e.new = true;
                if (e.parentS) {
                  e.imgP = "./assets/motor_n.png";
                  e.asset_type_s = s.asset_type;
                }

                switch (s.asset_type) {
                  case "MOTOR":
                    if (e.parentS) {
                      e.imgS = "./assets/motor_n.png";
                    } else {
                      e.imgP = "./assets/motor_n.png";
                    }
                    break;
                  case "GEAR":
                    if (e.parentS) {
                      e.imgS = "./assets/gearbox.png";
                    } else {
                      e.imgP = "./assets/gearbox.png";
                    }
                    break;
                  case "PUMP":
                    if (e.parentS) {
                      e.imgS = "./assets/pump.png";
                    } else {
                      e.imgP = "./assets/pump.png";
                    }
                    break;
                  case "FAN_BLOWER":
                    if (e.parentS) {
                      e.imgS = "./assets/fan.png";
                    } else {
                      e.imgP = "./assets/fan.png";
                    }
                    break;
                  case "JOURNAL_BEARING":
                    if (e.parentS) {
                      e.imgS = "./assets/bearing2.png";
                    } else {
                      e.imgP = "./assets/bearing2.png";
                    }
                    break;
                  case "COMPRESSOR":
                    if (e.parentS) {
                      e.imgS = "./assets/compressor.png";
                    } else {
                      e.imgP = "./assets/compressor.png";
                    }
                    break;
                }
              }
            });

            // e.connected_sensors.sort((a, b) =>
            //   a.parent > b.parent ? 1 : -1
            // );
            // e.connected_sensors.sort((a, b) => b.master - a.master);
            // e.connected_sensors.sort((a, b) => b.device_sno - a.device_sno);
          });
          this.deviceLoader = false;
          this.allDeviceSecondArray = this.allDevices;
        } else {
          this.deviceLoader =false;
          this.changeService.loader(false);
          this.allDeviceSecondArray = [];
          this.showEmptyError = "No Assets Available!";
        }
      } else {
        this.deviceLoader =false;
        this.changeService.loader(false);
        this.showEmptyError = "No Assets Available!";
        // this.service.showError("Something went wrong.");
      }

    });
  }
  cancelButton(){
    const navigationExtras={
      skipLocationChange: true,
      queryParams: {
      tabName:this.tabName,
        tab1:this.tab1,
        tab2:this.tab2,
        tab3:this.tab3,
        tab4:this.tab4,}
    }
    this.router.navigate(['eBoiler-room-devices'],navigationExtras);
  }
  onSubmit(){

  }
}
